var baseStyles = {"Input":"qL0NzJmihKo-","error":"XUGlCi-QG1w-","SelectWrapper":"YuRE1pVfz4U-","SelectChevron":"RQz2eA3Lx5s-","Label":"tUSa5fqfouc-","small":"_4l6RDOtHC0Y-","base":"_3G-Eo-8MfKc-","Description":"y-47vZlnzzg-"};

export { baseStyles as default };
//# sourceMappingURL=InputBase.module.css.js.map
